import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { AuthConfigService } from '../../Configuration/auth-config.service';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { BaseEntityModel } from '../../Data/Models/Common/base-entity-model';
import { User } from '../../Data/Models/Users/user';
import { UserLicenseDetailsModel } from '../../Data/Models/Users/user-license-details-model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

  baseUrl: any = this.configService.getAPIBaseUrl() + '/users';
  urlsubcription: any = this.configService.getsubscriptionURL() + '/Values/GetPlansInformation?CentralUserID=';
  currentUser: any;
  central_User_ID: any;
    productID: any;
    TableRecordCnt: any;
    numberOfUsers: string | number;
    planId: number;
    pricingID: number;

  constructor(private http: HttpClient, private authService: AuthConfigService, private configService: ConfigurationService, private authconfigService: AuthConfigService) { }

  //Get page one
  getUserLicenseDetails(userID: number): Observable<BaseEntityModel<UserLicenseDetailsModel>> {
    return this.http.get<BaseEntityModel<UserLicenseDetailsModel>>(this.baseUrl + '/GetUserLicenseDetails?userID=' + userID);
  }
  GetSubmitedCompanies(userID: number): Observable<BaseEntityModel<UserLicenseDetailsModel>> {
    return this.http.get<BaseEntityModel<UserLicenseDetailsModel>>(this.baseUrl + '/GetSubmitedCompanies?userID=' + userID);
  }

  GetsubmitedUTR(userID: number): Observable<BaseEntityModel<UserLicenseDetailsModel>> {
    return this.http.get<BaseEntityModel<UserLicenseDetailsModel>>(this.baseUrl + '/GetsubmitedUTR?userID=' + userID);
  }
  Getsubscriptioncheck(CentralUserID: any) {
    return this.http.get(this.urlsubcription + CentralUserID)
  }
  changePassword(emailId: any, password: any) {
    const form = new User();
    form.emailID = emailId;
    form.password = password;
    return this.http.post(this.baseUrl + '/ChangePassword', form, httpOptions);
  }
  CheckLicenceValidation(Central_UserId: number) {
    this.getUserLicenseDetails(Central_UserId).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      if (data.status == 0) {
        if (data.entity != null) {
          var userLicenceData = data.entity[0]
          this.productID = data.entity[0].productID;
          this.TableRecordCnt = data.entity[0].totalNoofCharitiescreated;
          this.numberOfUsers = data.entity[0].number_Of_Users >= 99999 ? 'Unlimited' : data.entity[0].number_Of_Users;
          this.planId = data.entity[0].planId;
          this.pricingID = data.entity[0].pricingId;
          const todayDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          const licenceEndDate = moment(userLicenceData.tuEndDate).utc().format('YYYY-MM-DD HH:mm:ss')
          const ms = moment(licenceEndDate).diff(todayDate)
          const isLicenceExpired = ms < 0 ? true : false
          if (isLicenceExpired) {
            if (userLicenceData.registrationType == 'PaidUser' || userLicenceData.registrationType == 'PaidUsers') {
              Swal.fire({
                title: 'Andica Charity Accounts',
                text: `Andica Charity Accounts Software licence has been expired on ${moment(userLicenceData.tuEndDate).utc().format('DD/MM/YYYY')}`,
                confirmButtonText: 'Renew',
                confirmButtonColor: '#6b816a',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showCancelButton: false,
                showCloseButton: false,
              }).then((result: SweetAlertResult) => {
                if (result.isConfirmed) {
                  this.Upgrade("Renew")
                }
              })
            }
          }
        }
      }
    })
  }

  Upgrade(Type: any) {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.currentUser = parsedUser.userID;

    }
    this.central_User_ID = localStorage.getItem("CentralUserId",)
    this.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.entity[0].userStatus == true) {
        var centralUserID = (this.central_User_ID).toString();

        var subscriptionURL = this.authconfigService.getSubscriptionAPIUrl();
        var prodId = (this.productID).toString();
        prodId = prodId.split('+').join('vkanslab');

        var encryptedDataProdID = CryptoJS.AES.encrypt(prodId, "My Secret Passphrase");
        var ProductID = encryptedDataProdID.toString();
        ProductID = ProductID.split('+').join('vkanslab');

        var encryptedData1 = CryptoJS.AES.encrypt(centralUserID, "My Secret Passphrase");
        var centralUserId = encryptedData1.toString();
        centralUserId = centralUserId.split('+').join('vkanslab');

        var name = ''
        if (Type == 'Upgrade') {
          var encryptedData2 = CryptoJS.AES.encrypt("Upgrade", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Renew') {
          var encryptedData2 = CryptoJS.AES.encrypt("Renew", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        }



        var encryptedData3 = CryptoJS.AES.encrypt(this.TableRecordCnt + "", "My Secret Passphrase");
        var numberOfCharitiesCreated = encryptedData3.toString();
        numberOfCharitiesCreated = numberOfCharitiesCreated.split('+').join('vkanslab');


        var encryptedData4 = CryptoJS.AES.encrypt("Annually", "My Secret Passphrase");
        var subType = encryptedData4.toString();
        subType = subType.split('+').join('vkanslab');


        var numOfUsers = this.numberOfUsers + "";
        var encryptedData5 = CryptoJS.AES.encrypt(numOfUsers, "My Secret Passphrase");
        var numberOfUsers = encryptedData5.toString();
        numberOfUsers = numberOfUsers.split('+').join('vkanslab');

        var StatusFrom = ''
        var PlanId = ''
        var PricingID = ''
        //upgrade from users
        if (Type == 'Upgrade' || Type == 'Renew') {
          var encryptedData6 = CryptoJS.AES.encrypt("FromCompanies", "My Secret Passphrase");
          StatusFrom = encryptedData6.toString();
          StatusFrom = StatusFrom.split('+').join('vkanslab');
          var encryptedDataPlanId = CryptoJS.AES.encrypt(this.planId + "", "My Secret Passphrase");
          PlanId = encryptedDataPlanId.toString();
          PlanId = PlanId.split('+').join('vkanslab');
          var encryptedDataPricingID = CryptoJS.AES.encrypt(this.pricingID + "", "My Secret Passphrase");
          PricingID = encryptedDataPricingID.toString();
          PricingID = PricingID.split('+').join('vkanslab');
        }
        debugger;
        var URL = "";
        //subscriptionURL ='https://subscriptions.dev.acuitysoft.com'   //for testing
        if (Type == 'Renew' || Type == 'Upgrade') {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        else {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        window.open(URL, '_self');
      } else {
        Swal.fire('', "This software license is deactivated .please contact Andica Sales.");
        return;
      }
    });
  }
}
